import {
  BucketAwtENUM,
  formatDateWithTimeAMPM,
  gridSizeMdLg10,
  gridSizeMdLg2,
  TipoParametroChoiceEnum,
  useUploadFile,
} from "@/shared";
import { EstadoMotivoEnum } from "@/shared/interfaces";
import { useAuthStore } from "@/store/auth";
import { useDiccionarioMotivo } from "@/store/erp/diccionario_motivo/diccionario_motivo.store";
import { useUiStore } from "@/store/ui";
import { Delete, Send } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ImageIcon from "@mui/icons-material/Image";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Grid,
  IconButton,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useEffect, useRef, useState } from "react";
import BitacoraMessage from "../bitacora_message/BitacoraMessage";
import "./BitacoraItemMotivo.css";

const handleColor = (estado: string, estado_motivo: string): string => {
  if (estado_motivo == EstadoMotivoEnum.RESUELTO) return "green";

  switch (estado) {
    case "ALTA":
      return "#D04848";
    case "RESUELTO":
      return "#F3B95F";
    case "MEDIA":
      return "orange";
    case "BAJA":
      return "#22559C";
    default:
      return "black";
  }
};

interface BitacoraItemMotivoProps {
  motivo_data: {
    _id: string;
    numero_referencia_motivo: string;
    descripcion: string;
    estado_motivo: string;
    prioridad: string;
  };
  numero_referencia_venta: string;
  diccionario_motivo_id: string;
  panelId: string;
  esLectura: boolean;
  fecha_creacion_motivo: string;
  fase_venta: string;
  //handleChange: (panel: string) => (_event: React.SyntheticEvent, isExpanded: boolean) => void
}

export default function BitacoraItemMotivo({
  //expanded,
  //handleChange
  panelId,
  motivo_data,
  numero_referencia_venta,
  diccionario_motivo_id,
  esLectura,
  fecha_creacion_motivo,
  fase_venta,
}: BitacoraItemMotivoProps) {
  const dataGetComentariosMotivos =
    useDiccionarioMotivo().dataGetComentariosMotivos;
  const handleChange = useDiccionarioMotivo().handleChange;
  const expanded = useDiccionarioMotivo().expanded;
  const emitEnviarComentario = useDiccionarioMotivo().emitEnviarComentario;
  const setExpanded = useDiccionarioMotivo().setExpanded;
  const emitActualizarMotivo = useDiccionarioMotivo().emitActualizarMotivo;
  const socket = useDiccionarioMotivo().socket;

  const setConfirmDialog = useUiStore((s) => s.setConfirmDialog);
  const selectedImage = useDiccionarioMotivo((s) => s.selectedImage);
  const setSelectedImage = useDiccionarioMotivo(
    (s) => s.setSelectedImageBitacora
  );
  const imagePreview = useDiccionarioMotivo((s) => s.imagePreview);
  const setImagePreview = useDiccionarioMotivo((s) => s.setImagePreview);

  const setConfirmDialogIsOpen = useUiStore((s) => s.setConfirmDialogIsOpen);

  const handleUploadFile = useUploadFile().handleUploadFile;

  const [valueText, setValueText] = useState<string>("");

  // Referencia al último elemento de la lista
  const messagesEndRef = useRef<HTMLDivElement | null>(null);
  const fileInputRef = useRef<HTMLInputElement>(null);

  const user = useAuthStore((s) => s.user);

  // Efecto para hacer scroll al último comentario cuando se actualiza la lista

  useEffect(() => {
    if (dataGetComentariosMotivos.comentarios.length == 0) return;

    const timeoutId = setTimeout(() => {
      if (messagesEndRef.current) {
        messagesEndRef.current.scrollIntoView({
          behavior: "smooth",
          block: "end",
        });
      }
    }, 100);

    //console.log(dataGetComentariosMotivos);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [dataGetComentariosMotivos]);

  // Actualiza la vista previa de la imagen cuando selectedImage cambia
  useEffect(() => {
    if (selectedImage) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result as string);
      };
      reader.readAsDataURL(selectedImage);
    } else {
      setImagePreview(null); // Limpia la vista previa si no hay imagen seleccionada
    }
  }, [selectedImage]);

  useEffect(() => {
    return () => {
      console.log("destruir componente");

      if (socket) {
        socket.emit("leaveRoom", user?.username!); //* TODO: converit en funcion
      }

      setExpanded(false);
    };
  }, []);

  const handleEnviarComentario = async () => {
    let respImage: string | null = null;

    if (selectedImage) {
      respImage = (
        await handleUploadFile(selectedImage, BucketAwtENUM.IMEGE_CHAT)
      ).url;
      setSelectedImage(null);
      setImagePreview(null);
    }

    emitEnviarComentario({
      comentario_texto: respImage ? respImage : valueText,
      tipo: respImage
        ? TipoParametroChoiceEnum.IMAGE
        : TipoParametroChoiceEnum.TEXTO,
      diccionario_motivo_id,
      numero_referencia_venta,
      motivo_id: motivo_data._id,
      username_create_venta: "admin",
    });

    setValueText("");
  };

  return (
    <Accordion
      style={{
        margin: "5px 0px",
        borderRadius: "3px",
      }}
      sx={{
        borderLeft: `4px solid ${handleColor(
          motivo_data.prioridad,
          motivo_data.estado_motivo
        )}`,
        "&:before": {
          display: "none",
        },
        "&.Mui-expanded": {
          margin: "8px 0",
        },
      }}
      /* disabled={
        esLectura
          ? false
          : motivo_data.estado_motivo === EstadoMotivoEnum.RESUELTO
      } */
      expanded={expanded === panelId}
      onChange={handleChange({
        panel: panelId,
        numero_referencia_venta,
        diccionario_motivo_id,
        motivo_id: motivo_data._id,
      })}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`${panelId}-content`}
        id={`${panelId}-header`}
      >
        <Grid container justifyContent={"space-between"} alignItems={"center"}>
          <Grid item xs={12}>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontSize: "12px",
                  background: `${handleColor(
                    motivo_data.prioridad,
                    motivo_data.estado_motivo
                  )}`,
                  color: "white",
                  borderRadius: "10px",
                  padding: "2px 10px",
                  border: `1px solid ${handleColor(
                    motivo_data.prioridad,
                    motivo_data.estado_motivo
                  )}`,
                  fontWeight: "bold",
                }}
              >
                {`${motivo_data.prioridad} - ${motivo_data.estado_motivo}`}
              </Typography>
              <Typography fontWeight={"bold"} variant="body2">
                {`${formatDateWithTimeAMPM(fecha_creacion_motivo)}`}
              </Typography>
            </div>

            {/* <Typography fontWeight={'bold'}
                variant="body2" >
                {`${fase_venta}`}</Typography> */}

            <Typography variant="subtitle2">
              {`${fase_venta} - ${motivo_data.descripcion}`}
            </Typography>
          </Grid>

          {/* <Grid item xs={12}>
            <div style={{ background: '#ccc', height: '1px' }}></div>
          </Grid> */}
        </Grid>
      </AccordionSummary>
      <AccordionDetails>
        <Grid
          container
          spacing={2}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Grid item xs={12}>
            <Box
              sx={{
                flexGrow: 1,
                overflow: "auto",
                p: "4px",
                maxHeight: "275px",
              }}
            >
              {dataGetComentariosMotivos &&
                dataGetComentariosMotivos.comentarios.length != 0 &&
                dataGetComentariosMotivos.comentarios.map((element) => {
                  return (
                    <>
                      <BitacoraMessage
                        key={element._id}
                        message={element.comentario}
                        sender={false}
                        timestamp={element.createdAt}
                        type={
                          element.tipo === TipoParametroChoiceEnum.IMAGE ||
                          /\.(png|jpe?g|gif|webp|bmp|svg)(\?.*)?$/i.test(element.comentario || '')
                            ? TipoParametroChoiceEnum.IMAGE
                            : TipoParametroChoiceEnum.TEXTO
                        }
                        user={`${element.departamento || 'TECNICO'}`}
                        visto_por_tipo={element.visto_por_tipo ?? ""}
                        visto_por={null}
                      />
                      <div ref={messagesEndRef} style={{ height: "1px" }} />
                    </>
                  );
                })}
            </Box>
          </Grid>

          {!esLectura &&
            motivo_data.estado_motivo != EstadoMotivoEnum.RESUELTO && (
              <>
                <Grid item {...gridSizeMdLg10}>
                  <TextField
                    disabled={
                      motivo_data.estado_motivo === EstadoMotivoEnum.RESUELTO
                    }
                    autoComplete="off"
                    autoCapitalize="off"
                    autoCorrect="off"
                    label="Comentario"
                    variant="outlined"
                    value={valueText}
                    onKeyDown={(e) =>
                      e.key === "Enter" && handleEnviarComentario()
                    }
                    onChange={(e) => {
                      setValueText(e.target.value);
                    }}
                    fullWidth
                    InputProps={{
                      endAdornment: (
                        <>
                          <IconButton
                            onClick={() => {
                              handleEnviarComentario();
                            }}
                          >
                            <Send />
                          </IconButton>

                          <input
                            type="file"
                            accept={"image/*"}
                            id={"image-upload"}
                            style={{ display: "none" }}
                            onChange={(event) => {
                              const file = event.target.files?.[0];
                              if (file && file.type.startsWith("image/")) {
                                console.log(file);

                                setSelectedImage(file);
                              }
                            }}
                            disabled={false}
                            ref={fileInputRef}
                          />
                          <label htmlFor={"image-upload"}>
                            <Tooltip title={"Cargar Imagen"}>
                              <IconButton
                                color="secondary"
                                component="span"
                                disabled={false}
                              >
                                <ImageIcon />
                              </IconButton>
                            </Tooltip>
                          </label>
                        </>
                      ),
                    }}
                  />
                </Grid>

                <Grid item {...gridSizeMdLg2}>
                  <Button
                    disabled={
                      motivo_data.estado_motivo === EstadoMotivoEnum.RESUELTO
                    }
                    onClick={() => {
                      setConfirmDialogIsOpen(true);
                      setConfirmDialog({
                        isOpen: true,
                        title: "¡Confirmar!",
                        subtitle:
                          "Por favor, confirma que el motivo ha sido resuelto. Una vez confirmado, las partes involucradas ya no podrán responder al motivo. ¿Estás seguro de continuar?",
                        onClose() {
                          setConfirmDialogIsOpen(false);
                        },
                        onConfirm() {
                          setConfirmDialogIsOpen(false);
                          emitActualizarMotivo({
                            diccionario_motivo_id,
                            motivo_id: motivo_data._id,
                            numero_referencia_venta,
                          });
                        },
                        cancelTextBtn: "Cerrar",
                      });
                    }}
                    color="success"
                    variant="outlined"
                  >
                    Resuelto
                  </Button>
                </Grid>
              </>
            )}

          {selectedImage && imagePreview && (
            <Grid>
              <div
                style={{
                  position: "relative",
                  width: "300px",
                  height: "200px",
                }}
              >
                <img
                  src={imagePreview}
                  alt="Imagen"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                  }}
                />
                <IconButton
                  className="image-button"
                  style={{
                    position: "absolute",
                    top: "5px",
                    right: "5px",
                    backgroundColor: "#fff",
                    borderRadius: "50%",
                    boxShadow: "0px 0px 5px rgba(0,0,0,0.3)",
                  }}
                  onClick={() => {
                    setSelectedImage(null);
                    setImagePreview(null);
                    if (fileInputRef.current) {
                      fileInputRef.current.value = "";
                    }
                  }}
                  size="small"
                >
                  <Delete fontSize="small" />
                </IconButton>
              </div>
            </Grid>
          )}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
